import React, { Fragment } from 'react';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './BulkUploadResults.styles';

export const BulkUploadResults = props => {
  return (
    <div className={css(styles.results)}>
      <span className={css(styles.field)}>
        <Translate value="add.bulkUpload.recordCount" />:
      </span>
      <span className={css(styles.value)}>{props.recordCount}</span>
      <span className={css(styles.field)}>
        <Translate value="add.bulkUpload.successCount" />:
      </span>
      <span className={css(styles.value)}>{props.successCount}</span>
      <span className={css(styles.field)}>
        <Translate value="add.bulkUpload.errorCount" />:
      </span>
      <span className={css(styles.value)}>{props.errorCount}</span>
      {props.errorCount > 0 && (
        <div className={css(styles.errors)}>
          <Translate
            value="add.bulkUpload.errorLine"
            className={css(styles.errorLine, styles.errorHeader)}
          />
          <Translate
            value="add.bulkUpload.errorText"
            className={css(styles.errorText, styles.errorHeader)}
          />
          {(props.errors || []).map(error => (
            <Fragment key={error.line}>
              <span className={css(styles.errorLine)}>{error.line}</span>
              <span className={css(styles.errorText)}>{error.text}</span>
            </Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default BulkUploadResults;



// WEBPACK FOOTER //
// ./src/components/forms/bulkupload/bulkuploadresults/BulkUploadResults.js